import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals/global.css";
import App from "./App";

import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

// QueryClient mit Default-Optionen für alle Queries
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ❶ Daten bleiben 5 Minuten fresh (werden nicht neu gefetched)
      staleTime: 5 * 60_000,
      // ❷ Unbenutzte Daten bleiben 30 Minuten im Cache (garbage collection)
      gcTime:    30 * 60_000,
      // ❸ kein automatisches Wiederholen von fehlgeschlagenen Requests
      retry:     false,
      // ❹ keine Refetches bei Window-Focus oder Reconnect
      refetchOnWindowFocus: false,
      refetchOnReconnect:   false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
